import type { PortfolioMetric } from "@eu.mdotm.api/sphere";
import type { PrintableProps } from "$root/components/EvolvedPrint/configuration/types";
import { Card } from "$root/components/EvolvedPrint/components/Card";
import { commonReportColumns } from "$root/components/EvolvedPrint/components/table/common-report-columns";
import { TinyTableDataCell, TinyTableHeadCell } from "$root/components/EvolvedPrint/components/table/tiny-table";
import { useReportTranslation } from "../translation";
import { type TableColumn, BaseTable } from "@mdotm/shadcn/legacy/components";

type CustomPortfolioMetric = PortfolioMetric & { unitOfMeasurement: string };
export function PortfolioMetrics({
	showBenchmark,
	list,
}: PrintableProps<{ showBenchmark: boolean }, CustomPortfolioMetric>): React.JSX.Element {
	const { t } = useReportTranslation();

	const columns = [
		{
			name: "type",
			width: 330,
			header: (props) => (
				<TinyTableHeadCell {...props}>{t("REPORT_BUILDER.PORTFOLIO_METRICS.TABLE.METRIC")}</TinyTableHeadCell>
			),
			content: ({ type }, props) => (
				<TinyTableDataCell {...props}>{`${t(`REPORT_BUILDER.PORTFOLIO_METRICS.METRICS.${type!}`)}`}</TinyTableDataCell>
			),
		},
		{
			...commonReportColumns.float<CustomPortfolioMetric>(
				"value",
				t("REPORT_BUILDER.PORTFOLIO_METRICS.TABLE.CURRENT"),
				{
					suffix: (row) => row.unitOfMeasurement,
				},
			),
			name: "current",
			width: 124,
		},
		{
			...commonReportColumns.float<CustomPortfolioMetric>(
				"benchmarkValue",
				t("REPORT_BUILDER.PORTFOLIO_METRICS.TABLE.BENCHMARK"),
				{ suffix: (row) => row.unitOfMeasurement },
			),
			name: "benchmark",
			width: 124,
			hidden: !showBenchmark,
		},
		{
			name: "empty",
			minWidth: 0,
			header: (props) => <TinyTableHeadCell {...props}>{null}</TinyTableHeadCell>,
			content: (_, props) => <TinyTableDataCell {...props}>{null}</TinyTableDataCell>,
		},
	] satisfies TableColumn<CustomPortfolioMetric>[];

	return (
		<Card title={t("REPORT_BUILDER.PORTFOLIO_METRICS.TITLE")}>
			<BaseTable
				disableVirtualScroll
				palette="uniform"
				columns={columns}
				rows={list}
				noDataText={t("COMPOSITION.NO_COMPOSITION")}
			/>
		</Card>
	);
}
